import { DateFormatType } from './date-format-key'
import type { IDatePatterns } from './i-date-patterns'
import type { IResolvedDateFormat } from './i-resolved-date-format'

export const DATE_FORMAT_PATTERNS: Record<IResolvedDateFormat, IDatePatterns> = {
  [DateFormatType.DdMm]: {
    dateOnly: 'DD/MM/YYYY',
    dayOnly: 'DD/MM',
    dayHumanizedMonth: 'D MMMM',
    dateWithShortMonth: 'DD MMM YYYY',
    dateLongMonth: 'DD MMMM YYYY',
    dayLongMonth: 'dddd, MMMM D',
  },
  [DateFormatType.MmDd]: {
    dateOnly: 'MM/DD/YYYY',
    dayOnly: 'MM/DD',
    dayHumanizedMonth: 'MMMM D',
    dateWithShortMonth: 'MMM D, YYYY',
    dateLongMonth: 'MMMM D, YYYY',
    dayLongMonth: 'dddd, MMMM D',
  },
}
